<template>
  <div>
    <div class="d-flex justify-content-end mx-4 my-2">
      <span
        ><strong>{{ situacaoComputed }}</strong></span
      >
    </div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres
          titulo="Novo Edital"
          :botoes="botoesHeader"
          breakpoint="xl"
        />
      </template>
      <b-tabs card>
        <b-tab title="Dados Gerais">
          <AbaCadastroConcurso
            @editalCriado="habilitarAbas"
            :idEdital="idEdital"
          />
        </b-tab>

        <b-tab v-if="idEdital > 0" title="Anexos">
          <AbaAnexoConcurso :idEdital="idEdital" :idTipoEdital="edital.IdTipoEdital" :contador="contador" />
        </b-tab>

        <b-tab
          v-if="idEdital > 0"
          :title="edital.IdTipoEdital === 3 ? 'Funções' : 'Cargos'"
        >
          <AbaCargosConcurso :idEdital="idEdital" />
        </b-tab>
      </b-tabs>
    </b-card>

    <ModalPendencias
      v-if="openModal"
      :edital="edital"
      @close="closeModalPendencias"
    />
    <ModalPendenciasHomologacao
      v-if="openModalHml"
      :edital="edital"
      @close="closeModalPendenciasHml"
    />
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import AbaCadastroConcurso from "@/components/atos-pessoal/concursos/AbaCadastrarConcurso.vue";
import AbaAnexoConcurso from "@/components/atos-pessoal/concursos/AbaAnexoConcurso.vue";
import AbaCargosConcurso from "@/components/atos-pessoal/concursos/AbaCargosConcurso.vue";
import { EditalConcurso } from "@/types/atos-pessoal/concursos/edital";
import { BotaoSagres } from "@/types/botao-sagres";
import concursoService from "@/services/atos-pessoal/concursoService";
import ModalPendencias from "@/components/atos-pessoal/concursos/ModalPendencias.vue";
import ModalPendenciasHomologacao from "@/components/atos-pessoal/concursos/ModalPendenciasHomologacao.vue";

const CompProps = Vue.extend({
  name: "CriarConcurso",
  components: {
    HeaderSagres,
    AbaCadastroConcurso,
    AbaAnexoConcurso,
    AbaCargosConcurso,
    ModalPendencias,
    ModalPendenciasHomologacao,
  },
});

@Component
export default class CriarConcurso extends mixins(UtilsTS, CompProps) {
  idEdital = 0;
  contador = 0;
  openModal = false;
  openModalHml = false;
  edital = new EditalConcurso();
  botoesHeader: BotaoSagres[] = [
    {
      id: -1,
      icone: "arrow-left",
      texto: "Voltar",
    },
  ];

  get situacaoComputed() {
    switch (this.edital.IdSituacao) {
      case 1:
        return "Situação: Em Cadastramento";
      case 2:
        return "Situação: Homologado";
      case 3:
        return "Situação: Cancelado";
      case 4:
        return "Situação: Cadastrado";
      default:
        return "";
    }
  }

  async carregarEdital(idEdital: number) {
    try {
      const response = await concursoService.getConcursoById(idEdital);
      this.edital = new EditalConcurso(response);
      this.botoesHeader = [this.botoesHeader[0]];
      if (this.edital.IdSituacao === 1)
        this.botoesHeader.push({
          id: 1,
          texto: "Pendências Cadastro",
          icone: "clipboard-check",
          acao: this.openModalPendencias,
        });
      else if (this.edital.IdSituacao === 4)
        this.botoesHeader.push({
          id: 2,
          texto: "Pendências Homologação",
          icone: "clipboard-check",
          acao: this.openModalPendenciasHml,
        });
    } catch (e: any) {
      this.tratarError(e);
    }
  }

  openModalPendencias() {
    this.openModal = true;
  }
  closeModalPendencias() {
    this.openModal = false;
  }

  openModalPendenciasHml() {
    this.openModalHml = true;
  }
  closeModalPendenciasHml() {
    this.openModalHml = false;
  }

  habilitarAbas(data) {
    this.idEdital = data.IdEdital;
    this.$router.push(
      `/atos-pessoal/concursos/editar-edital/${this.idEdital}/0`
    );
  }
}
</script>
